import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'sort',
  name: 'Sort',
  category: 'utilities',
  description: 'Sort items by one or more fields in ascending or descending order',
  icon: 'ArrowUpDown',
  color: 'cyan',
  version: '1.2.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'Sort',
    color: '#06b6d4'
  },
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['sort', 'order', 'arrange', 'organize'],
  
  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.sort/'
  }
};

export default definition;
